"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpactMarketUBIManagementSubgraph = exports.ImpactMarketSubgraph = void 0;
const client_1 = require("@apollo/client");
const retry_1 = require("@apollo/client/link/retry");
const config_1 = require("./config");
const defaultRetryOptions = {
    attempts: {
        max: 15,
        retryIf: (error, _operation) => !!error
    },
    delay: {
        initial: 7000,
        jitter: true,
        max: Infinity
    }
};
class ImpactMarketSubgraph {
    constructor(networkId = config_1.networksId.CeloAlfajores, options) {
        const retry = new retry_1.RetryLink((options === null || options === void 0 ? void 0 : options.retry) || defaultRetryOptions);
        const http = new client_1.HttpLink({
            uri: networkId === config_1.networksId.CeloAlfajores ? config_1.subgraphCeloAlfajores : config_1.subgraphCeloMainnet
        });
        this.client = new client_1.ApolloClient({
            cache: (options === null || options === void 0 ? void 0 : options.cache) || new client_1.InMemoryCache(),
            link: (0, client_1.from)([retry, http])
        });
    }
    async findBeneficiaries(beneficiaries, query) {
        const result = await this.client.query({
            query: (0, client_1.gql) `
                {
                    beneficiaryEntities(where: { id_in: [${beneficiaries.map(b => `"${b.toLowerCase()}"`)}] }) ${query}
                }
                `
        });
        return result.data.beneficiaryEntities;
    }
    async getBeneficiaryData(beneficiary, query) {
        const result = await this.client.query({
            query: (0, client_1.gql) `
                {
                    beneficiaryEntity(id: "${beneficiary.toLowerCase()}") ${query}
                }
                `
        });
        return result.data.beneficiaryEntity;
    }
    async getCommunityData(community, query) {
        const result = await this.client.query({
            query: (0, client_1.gql) `
                {
                    communityEntity(id: "${community.toLowerCase()}") ${query}
                }
                `
        });
        return result.data.communityEntity;
    }
    async getDepositRedirectTokens() {
        const result = await this.client.query({
            query: (0, client_1.gql) `
                {
                    depositRedirectTokens(where: { active: true }) {
                        id
                        deposited
                        interest
                    }
                }
            `
        });
        return result.data.depositRedirectTokens;
    }
    async getUserDeposits(depositorAddress) {
        var _a;
        const result = await this.client.query({
            query: (0, client_1.gql) `
                {
                    depositor(id: "${depositorAddress.toLowerCase()}") {
                        assets {
                            asset
                            deposited
                            interest
                        }
                    }
                }
                `
        });
        return ((_a = result.data.depositor) === null || _a === void 0 ? void 0 : _a.assets) || [];
    }
}
exports.ImpactMarketSubgraph = ImpactMarketSubgraph;
class ImpactMarketUBIManagementSubgraph {
    constructor(provider, networkId = config_1.networksId.CeloAlfajores, options) {
        const retry = new retry_1.RetryLink((options === null || options === void 0 ? void 0 : options.retry) || defaultRetryOptions);
        const http = new client_1.HttpLink({
            uri: networkId === config_1.networksId.CeloAlfajores
                ? config_1.ubiManagementSubgraphCeloAlfajores
                : config_1.ubiManagementSubgraphCeloMainnet
        });
        this.client = new client_1.ApolloClient({
            cache: (options === null || options === void 0 ? void 0 : options.cache) || new client_1.InMemoryCache(),
            link: (0, client_1.from)([retry, http])
        });
        this.provider = provider;
    }
    async getProposals(first, skip, quorumVotes, userAddress) {
        const blockNumber = await this.provider.getBlockNumber();
        const result = await this.client.query({
            query: (0, client_1.gql) `
                {
                    proposalEntities(first: ${first} skip: ${skip} orderBy: createdAt orderDirection: desc) {
                        id
                        createdAt
                        proposer
                        signatures
                        endBlock
                        description
                        status
                        votedAgainst
                        votedFor
                        votedAbstain
                    }
                }
                `
        });
        // eslint-disable-next-line no-nested-ternary
        const userVoted = (proposal) => 
        // eslint-disable-next-line no-nested-ternary
        proposal.votedAgainst.includes(userAddress === null || userAddress === void 0 ? void 0 : userAddress.toLowerCase())
            ? 0
            : // eslint-disable-next-line no-nested-ternary
                proposal.votedFor.includes(userAddress === null || userAddress === void 0 ? void 0 : userAddress.toLowerCase())
                    ? 1
                    : proposal.votedAbstain.includes(userAddress === null || userAddress === void 0 ? void 0 : userAddress.toLowerCase())
                        ? 2
                        : -1;
        return result.data.proposalEntities.map((proposal) => (Object.assign(Object.assign({}, proposal), { 
            // eslint-disable-next-line no-nested-ternary
            status: 
            // eslint-disable-next-line no-nested-ternary
            proposal.status === 2
                ? 'canceled'
                : // eslint-disable-next-line no-nested-ternary
                    proposal.status === 1
                        ? 'executed'
                        : // eslint-disable-next-line no-nested-ternary
                            proposal.votedAgainst.length >= quorumVotes
                                ? 'defeated'
                                : // eslint-disable-next-line no-nested-ternary
                                    proposal.votedFor.length >= quorumVotes
                                        ? 'ready'
                                        : proposal.endBlock < blockNumber
                                            ? 'expired'
                                            : 'active', userVoted: userVoted(proposal), votesAbstain: proposal.votedAbstain.length, votesAgainst: proposal.votedAgainst.length, votesFor: proposal.votedFor.length })));
    }
}
exports.ImpactMarketUBIManagementSubgraph = ImpactMarketUBIManagementSubgraph;
//# sourceMappingURL=subgraphs.js.map